import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import { AlertService } from '../../../../../services/alert.service';
import { ModalService } from 'shared/services/modal.service';
import { PreloaderService } from '../../../../../services/preloader.service';
import { JobInstructionApi,JobAcknowledgementApi,CommentApi } from '../../../../../sdk';
import { CommonService } from 'shared/services/common.service';
import { concernType } from 'shared/models/static-list-data.service';


@Component({
    selector: 'job-acknowledgement',
    templateUrl: './job-acknowledgement.component.html',
    styleUrls: ['./job-acknowledgement.component.css']
})

export class JobAcknowledgementComponent implements OnInit {
    concernTypeForm: FormGroup;
    @Input() jobId: string;
    @Input() jobObj: any;

    jobInstruction: Array<any>;
    errorMessage: string;
    tools: Array<any>;
    raiseFlag : Boolean = false;
    concernType : any;
    jobData: any;
    loggedInContact : any; 
    loggedInEmail = '';

    constructor(
        public fb: FormBuilder,
        private _jobInstructionApi: JobInstructionApi,
        private _jobAcknowledgementApi: JobAcknowledgementApi,
        private _commentApi: CommentApi,

        private _alertService: AlertService,
        private _preloaderService: PreloaderService,
        private _commonService: CommonService,
        private _modalService: ModalService,
    ) { }

    ngOnInit() {
        this.concernType = concernType
        if (this.jobId) { 
            const appData = JSON.parse(localStorage.getItem('appData'));
            if (appData && appData['user'] && appData['user']['contact'] && appData['user']['contact']['sfdcId']) {
            this.loggedInContact = appData['user']['contact'];
            this.loggedInEmail = appData['user'].email;
            }
            this.prepareJobData(JSON.parse(this.jobObj))
            if (sessionStorage.getItem(`jobInstruction_${this.jobId}`) === null) {
                this.getInstructionDetails(this.jobId);
            } else {
                this.jobInstruction = JSON.parse(sessionStorage.getItem(`jobInstruction_${this.jobId}`));
                this.errorMessage = (this.jobInstruction.length > 0) ? '' : 'Global Program Instructions not available for this job.';
            }
        }
    }

    prepareJobData(result) {
        if (result && Object.keys(result).length > 0) {
            this.jobData = result;

            let address = '';
            if (this.jobData.jobsite) {
                address += this.jobData.jobsite.Street__c ? this.jobData.jobsite.Street__c + ' ' : '';
                address += this.jobData.jobsite.City__c ? this.jobData.jobsite.City__c + ', ' : '';
                address += this.jobData.jobsite.State__c ? this.jobData.jobsite.State__c + ', ' : '';
                address += this.jobData.jobsite.Zip__c ? this.jobData.jobsite.Zip__c + ', ' : '';
                address += this.jobData.jobsite.Country__c ? this.jobData.jobsite.Country__c : '';
                this.jobData.address = address;

                if(this.jobData.appointment){
                    const timeFormat = 'L, LT z';
                    this.jobData.Customer_Appointment_DateTime_Scheduled__c =
                    this._commonService.dateFormate(this.jobData.appointment.Customer_Appointment_DateTime_Scheduled__c,
                        this.jobData.jobsite.Time_Zone__c, timeFormat);
                }
            }
        }
        this._preloaderService.hidePreloader();
    }

    initializeConcernTypeForm() {
        this.concernTypeForm = this.fb.group({
          concernType__c: new FormControl(null, [Validators.required]),
          remark: new FormControl(null, [Validators.required]),
               
        });
      }

    getInstructionDetails(id) {
        this._preloaderService.showPreloader();
        this._jobInstructionApi.find({
            'where': {
                'Job__c': id,
                'IsDeleted': 0
            },
            'include': [
                {
                    'relation': 'Job',
                    'scope': {
                        'fields': ['Special_Instruction_from_PMS_Case_Auto__c', 'csum__c','Custom_work_order_instructions__c', 'Partner_Case_Error_Description__c']
                    }
                }
            ]
        }).subscribe(
            jobInstruction => {
                if (jobInstruction && jobInstruction.length) {
                    this.jobInstruction = jobInstruction;
                    this.jobInstruction.forEach(function (ele) {
                        ele['tools'] = ele.Job_Instructions_Required_Tools__c && ele.Job_Instructions_Required_Tools__c.length
                            ? ele.Job_Instructions_Required_Tools__c.split('\r\n') : [];
                    });
                    sessionStorage.setItem(`jobInstruction_${this.jobId}`, JSON.stringify(this.jobInstruction))
                } else {
                    this.errorMessage = 'Global Program Instructions not available for this job.';
                }
                this._preloaderService.hidePreloader();
            }, error => {
                this._preloaderService.hidePreloader();
                this.errorMessage = error.message;
            }
        );
    }

    openRaiseFlag(){
        this.raiseFlag = !this.raiseFlag;
        this.initializeConcernTypeForm();
    }

    submitRequest() {
        this._preloaderService.showPreloader();
        const data = this.concernTypeForm.value;

        let reqObj = this.prepareAckData('concern');
        reqObj['concernType__c'] = data.concernType__c;
        reqObj['remark'] = data.remark

        this._jobAcknowledgementApi.create(reqObj).subscribe(reply => {
            setTimeout(() => {
                this.sendMessage('concern');
              this._preloaderService.hidePreloader();
              this.closePopup();
              this._alertService.success('Concern raised successfully.');

            }, 1500);
          }, err => {
            console.log(err);
            this.closePopup();
            this._preloaderService.hidePreloader();
          });
    }

    acknowledge(){
        this._preloaderService.showPreloader();
        let reqObj = this.prepareAckData('ack');
        this._jobAcknowledgementApi.create(reqObj).subscribe(reply => {
            setTimeout(() => {
                this.sendMessage('ack');
              this._preloaderService.hidePreloader();
              this.closePopup();
              this._alertService.success('Acknowledged successfully.');

            }, 1500);
          }, err => {
            console.log(err);
            this.closePopup();
            this._preloaderService.hidePreloader();
          });
    }

    sendMessage(type) {
        let msg = '';
        if(type == 'ack'){
            msg = 'pre visit acknowledgement completed by worker'
        }else{
            msg = 'Flag raised by worker'
        }
        let commentData = {
            modelName: "Job",
            modelId: this.jobData.id.toString(),
            messageType: "worker-visit-status",
            Is_Public_Job__c: true,
            Is_Public__c: false,
            isPrivate: true,
            commentType: 'icc',
            Case__c: this.jobData.Case__c,
            Job__c: this.jobData.sfdcId,
            postByName: this.loggedInEmail,
            ownerId: this.loggedInContact.id,
            Is_Auto_Bitly: false,
            Contact__c: this.loggedInContact.sfdcId,
            Case_Comment_Body__c: 'pre visit acknowledgement completed by worker'
        };


        this._commentApi.sendMessage(commentData).subscribe(
            result => {
                if (result) {
                    console.log('success')
                }
            },
            err => {
                console.log('message error')
                if (err.statusCode === '413') {
                    err.message = 'Message size too large!';
                }
                // this._alertService.error(err.message);
                // window.scrollTo(0, 0);
            }
        );

    }



    closePopup() {
        this._modalService.closed();
      }

    prepareAckData(type){
       
            const userAgent = window.navigator.userAgent;
        
            let browserName = '';
            let fullVersion = '';
        
            if (userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Edge') === -1 && userAgent.indexOf('OPR') === -1) {
              browserName = 'Chrome';
              fullVersion = userAgent.substring(userAgent.indexOf('Chrome') + 7).split(' ')[0];
            } else if (userAgent.indexOf('Firefox') > -1) {
              browserName = 'Firefox';
              fullVersion = userAgent.substring(userAgent.indexOf('Firefox') + 8);
            } else if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1) {
              browserName = 'Safari';
              fullVersion = userAgent.substring(userAgent.indexOf('Version') + 8).split(' ')[0];
            } else if (userAgent.indexOf('OPR') > -1) {
              browserName = 'Opera';
              fullVersion = userAgent.substring(userAgent.indexOf('OPR') + 4);
            } else if (userAgent.indexOf('Edge') > -1) {
              browserName = 'Edge';
              fullVersion = userAgent.substring(userAgent.indexOf('Edge') + 5);
            } else if (userAgent.indexOf('Trident/') > -1) {
              browserName = 'Internet Explorer';
              fullVersion = userAgent.substring(userAgent.indexOf('rv:') + 3).split(')')[0];
            }
        
        let ackObj = {
            'JobSfdcId': (this.jobData && this.jobData.sfdcId) ? this.jobData.sfdcId : null,
            'PreVisitStartDate': new Date(),
            'PreVisitAcknowledgeDate': new Date(),
            'SubmittedById': (this.loggedInContact) ? this.loggedInContact.sfdcId : null,
            'Jobsite_ID__c': (this.jobData && this.jobData.Jobsite__c) ? this.jobData.Jobsite__c : null,
            'WorkerId': (this.jobData && this.jobData.worker) ? this.jobData.worker.sfdcId : null,
            'PartnerId': (this.jobData && this.jobData.CKSW_BASE__Account__c) ? this.jobData.CKSW_BASE__Account__c : null,
            'ProgramId': (this.jobData && this.jobData.Project_SOP__c) ? this.jobData.Project_SOP__c : null,
            'VendorId': (this.jobData && this.jobData.Vendor__c) ? this.jobData.Vendor__c : null,
            'BrowserName': browserName,
            'BrowserMetaData': userAgent,
            'DeviceType': window.navigator.platform
        }
        if(type== 'ack'){
            ackObj['isAcknowledge'] = true;
        }
        return ackObj;
    }
}
